import N8nInput from './Input.vue';

export default N8nInput;
